import { useEffect, useState } from 'react';
import {
  fetchAndActivate,
  getValue,
  RemoteConfig,
} from 'firebase/remote-config';

export const useRemoteConfig = <T = unknown>(
  remoteConfig: RemoteConfig,
  key: string,
) => {
  const [value, setValue] = useState<T | undefined>();

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        await fetchAndActivate(remoteConfig);
        const fetchedValue = getValue(remoteConfig, key);
        setValue(JSON.parse(fetchedValue.asString()));
      } catch (error) {
        console.error('Failed to fetch Remote Config', error);
      }
    };

    fetchConfig();
  }, [key]);

  return value;
};
